import { useGetInfo } from "antopolis-react-utils/hooks";
import { useAxiosInstance } from "../../../../../Utilities/Hooks/useAxiosInstance";
import { Image } from "../../../../Partials/Elements/Image/Image";

function ViewHeroSlider({
    targetID,
    api
}) {

    const axiosInstance = useAxiosInstance();

    const { info: heroSlider } = useGetInfo({
        axiosInstance: axiosInstance,
        api: api + 'singleHeroSlider/' + targetID,
    })


    return (

        <div className="crud_view_content">

            {heroSlider &&
                <>
                    {/* <h1>Title</h1>
                    <p>HeroSlider</p> */}

                    <h1>Image</h1>
                    <Image
                        imgLink={heroSlider.image}
                        imgAlt={'info'}
                        className={''}
                    />


                </>
            }
        </div>
    )
}

export default ViewHeroSlider